import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Home from './pages/Home';
import Takk from './pages/Takk';
import Klinikker from './pages/Klinikker';
import ClinicProfile from './pages/ClinicProfile';
import CategoryPage from './pages/CategoryPage';
import CityTreatment from './pages/CityTreatment';
import Priser from './pages/Priser';
import PriceGuide from './pages/PriceGuide';
import Artikler from './pages/Artikler';
import Article from './pages/Article';
import ForKlinikker from './pages/ForKlinikker';
import Sok from './pages/Sok';
import OmOss from './pages/OmOss';
import SlikFungererDet from './pages/SlikFungererDet';
import Personvern from './pages/Personvern';
import Cookies from './pages/Cookies';
import TreatmentLanding from './pages/TreatmentLanding';
import { TREATMENTS } from './data/treatments';

import AdminLogin from './pages/AdminLogin';
import AdminLayout from './pages/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import AdminLeads from './pages/AdminLeads';
import AdminTrafikk from './pages/AdminTrafikk';
import AdminKlinikker from './pages/AdminKlinikker';
import AdminInnstillinger from './pages/AdminInnstillinger';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/takk" element={<Takk />} />
        <Route path="/klinikker" element={<Klinikker />} />
        <Route path="/klinikker/:id" element={<ClinicProfile />} />
        <Route path="/behandlinger/:kategori" element={<CategoryPage />} />
        <Route path="/behandlinger/:kategori/:by" element={<CityTreatment />} />
        <Route path="/priser" element={<Priser />} />
        <Route path="/priser/:behandling" element={<PriceGuide />} />
        <Route path="/artikler" element={<Artikler />} />
        <Route path="/artikler/:slug" element={<Article />} />
        <Route path="/for-klinikker" element={<ForKlinikker />} />
        <Route path="/sok" element={<Sok />} />
        <Route path="/om-oss" element={<OmOss />} />
        <Route path="/slik-fungerer-det" element={<SlikFungererDet />} />
        <Route path="/personvern" element={<Personvern />} />
        <Route path="/cookies" element={<Cookies />} />

        {/* Treatment-specific landing pages (e.g. /botox, /fillers, /invisalign...) */}
        {Object.keys(TREATMENTS).map((slug) => (
          <Route key={slug} path={`/${slug}`} element={<TreatmentLanding slug={slug} />} />
        ))}

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="henvendelser" element={<AdminLeads />} />
          <Route path="trafikk" element={<AdminTrafikk />} />
          <Route path="klinikker" element={<AdminKlinikker />} />
          <Route path="innstillinger" element={<AdminInnstillinger />} />
        </Route>

        {/* Unknown route -> home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
